import React, {ReactNode, useEffect, useRef} from 'react';

/**
 * Wraps a panel that closes once it has been seen and then scrolled fully out
 * of sight (Android's gate panel: onGloballyPositioned, zero height in the
 * window after it was shown once). The observer's viewport clips by every
 * scrolling ancestor, so the record's own scroll area counts.
 */
export const ClosesOutOfSight = ({onGone, children}: {onGone: () => void; children: ReactNode}) => {
  const box = useRef<HTMLDivElement>(null);
  const gone = useRef(onGone);
  gone.current = onGone;
  useEffect(() => {
    const element = box.current;
    if (!element || typeof IntersectionObserver === 'undefined') return;
    let seen = false;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) seen = true;
      else if (seen) gone.current();
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return <div ref={box}>{children}</div>;
};
